import { useState, type ReactNode } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

interface FooterColumnProps {
  title: string;
  children: ReactNode;
}

function FooterColumn({ title, children }: FooterColumnProps) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-primary-200/60 py-3 md:border-none md:py-0">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between text-left md:cursor-default"
      >
        <span className="text-sm font-bold tracking-wide text-foreground-900">{title}</span>
        <i className={`ri-add-line text-lg text-foreground-500 md:hidden ${open ? "rotate-45" : ""} transition-transform`} />
      </button>
      <div className={`${open ? "mt-2 block" : "hidden"} md:mt-3 md:block`}>{children}</div>
    </div>
  );
}

export default function Footer() {
  return (
    <footer className="w-full border-t border-primary-200/60 bg-primary-50">
      <div className="w-full px-4 py-10 md:px-8 md:py-12">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-12 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-vidicon-2-fill text-xl" />
              </span>
              <span className="font-heading text-lg font-black tracking-tight text-foreground-950">
                吃瓜视频
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-6 text-foreground-700">
              吃瓜视频是一个聚焦娱乐资讯与热点内容的视频门户，聚合明星动态、社会热点、趣味短片等多元内容，
              让每一次打开都值得期待。
            </p>
            <div className="mt-4 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-primary-600">
                <i className="ri-wechat-line text-lg" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-primary-600">
                <i className="ri-weibo-line text-lg" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-primary-600">
                <i className="ri-bilibili-line text-lg" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-primary-600">
                <i className="ri-youtube-line text-lg" />
              </span>
            </div>
          </div>

          <div className="md:col-span-3">
            <FooterColumn title="内容分类">
              <ul className="space-y-2">
                {categories.map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.id}`}
                      className="text-sm text-foreground-700 transition-colors hover:text-primary-600"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </FooterColumn>
          </div>

          <div className="md:col-span-2">
            <FooterColumn title="关于本站">
              <ul className="space-y-2">
                <li>
                  <Link to="/about" className="text-sm text-foreground-700 transition-colors hover:text-primary-600">
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link to="/search" className="text-sm text-foreground-700 transition-colors hover:text-primary-600">
                    全站搜索
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-700 transition-colors hover:text-primary-600">
                    意见反馈
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-700 transition-colors hover:text-primary-600">
                    隐私声明
                  </Link>
                </li>
              </ul>
            </FooterColumn>
          </div>

          <div className="md:col-span-2">
            <FooterColumn title="联系我们">
              <ul className="space-y-2 text-sm text-foreground-700">
                <li className="flex items-start gap-2">
                  <span className="mt-0.5 flex h-4 w-4 items-center justify-center text-primary-500">
                    <i className="ri-mail-line text-base" />
                  </span>
                  hello@chiguatv.com
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-0.5 flex h-4 w-4 items-center justify-center text-primary-500">
                    <i className="ri-phone-line text-base" />
                  </span>
                  400-000-8888
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-0.5 flex h-4 w-4 items-center justify-center text-primary-500">
                    <i className="ri-map-pin-line text-base" />
                  </span>
                  上海市静安区创意园区 A 座 12 层
                </li>
              </ul>
            </FooterColumn>
          </div>
        </div>

        <div className="mt-8 flex flex-col gap-3 border-t border-primary-200/60 pt-6 text-xs text-foreground-600 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 吃瓜视频 CHIGUA TV · 本站视频与图文内容均为演示用途</p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span>友情链接：人民文娱 · 影视观察 · 城市纪录</span>
            <span className="hidden sm:inline">沪ICP备0000000号</span>
          </div>
        </div>
      </div>
    </footer>
  );
}